import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

export default props => {
  const {
    open,
    onClose,
    title,
    content,
    maxWidth = 'md',
  } = props

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll='paper'
      aria-labelledby='scroll-dialog-title'
      aria-describedby='scroll-dialog-description'
      fullWidth
      maxWidth={maxWidth}
    >
      <DialogTitle id='scroll-dialog-title'>
        {title}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText
          id='scroll-dialog-description'
          tabIndex={-1}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='default'>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
